// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/styles/" + chunkId + "." + {"2374":"e41536665fd1879a28a2","2399":"3eb8c5bd32630b67e2b2","4438":"517cacbb8c2c756b72cd","4655":"922de29071060a48dbb3","5947":"bf4dba8a788789331774","7301":"661d2ff8af93d0881639"}[chunkId] + ".css";
};